<template>
<div  v-if="visible">
    <div class="dim">
        <div class="pwlayer">
            <a type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" @click="close()" style="cursor: pointer;">
                    <img src="../assets/img/modal-close.png" alt="">
                </span>
            </a>
            <div class="modal-header txt-center">
                <h2 class="bold">계정잠금 해제하기</h2>
            </div>
            <div class="modal-body txt-center">                    
                <p class="mt-05">
                    로그인 5회 연속 실패로 차단되었습니다.<br>
                    계정 확인을 위해 ID(E-mail)을 입력해 주세요.
                </p>                    
                <div class="mt-20 model-box">
                    <label for="">
                        <input type="text" placeholder="ID(E-mail)을 입력해 주세요." class="w-100per txt-left" v-model="email">
                    </label>
                    <p class="col-red mt-05 txt-left mb-20 pt-10 pl-10 pr-10"><span class="col-red">*</span>계정 확인 메일은 등록된 E-mail로 발송되며, 등록된 E-mail이 없을 시 ID로 등록된 E-mail로 발송됩니다.</p>
                </div>
            </div>
            <div class="modal-footer">
                <a class="btn-modal  pointer" @click="sendMail()">확인</a>
            </div>
        </div>  
    </div>
</div>
   
</template>
<script>
// import { getLightnessStep } from '@amcharts/amcharts4/.internal/core/utils/Colors';
export default {
  name: 'findPwModal',
    props: {
        visible: {
            type: Boolean,
            require: true,
            default: false
        }
    },

data: () => ({
    email:""
}),

mounted() {
    
},

methods: {
        close() {
            this.$emit("close",false);
        },
        sendMail(){
             if(location.hostname == "stagest.carrotenglish.net"){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else if(location.hostname == "st.carrotenglish.net"){
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }else if(location.hostname == "student.carrotenglish.net"){
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }else if(location.hostname == "m.carrotenglish.net"){
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }else if(location.href.includes("how")){
                if(location.href.includes("stage")){
                    this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
                }else{
                    this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                }
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
            var me = this;
            if(this.email == ""){
                alert("이메일을 입력해주세요.");
                return false;
            }

            var params = {
                email : this.email,
                access_code: Math.random().toString(36).substr(2,11)
            };
            this.axios.post(this.$store.state.host + '/rest/mobile/sendUnLockAccount', params).then(function(res){
                // console.log(res);
                if(res.data.err == 0){
                    alert("메일을 발송하였습니다.");
                    me.close();
                }else{
                    alert(res.data.err_msg);
                }
            });
        }
    }
}
</script>
<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');


$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9; 
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.dim{
    background: rgba(0,0,0,0.7);
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 55;
    box-sizing: border-box;

    .pwlayer{
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 20px #0000001A;
        border-radius: 20px;
        width: 90%;
        margin: 0 auto;
        max-width: 500px;
        margin-top: 50px;
        position: relative;
        .modal-header{
            h2{
                text-align: center;
                letter-spacing: 0px;
                color: #53CAFF;
                opacity: 1;
                font-size: 20px;
                font-weight: bold;
            }
            margin-bottom: 15px;
        }
        .modal-body{
            padding: 0 20px;
            p{
                text-align: center;
                letter-spacing: 0px;
                color: #000000;
                opacity: 1;
                font-size: 14px;
            }
            .model-box{
                label{
                    width: 100%;
                }
            }
        }
    }

}
input[type="text"], input[type="password"]{
  border-radius: 0;
    border-top: none;
    border-right: none;
    border-left: none;
    border-bottom: 1px solid #E9E9E9;
    font-size: 16px;
    height: 45px;
    padding: 0 10px;
}
.modal-footer{
    a{
        background: #53CAFF 0% 0% no-repeat padding-box;
        color: white;
    }
}
// .btn-modal {
//     font-weight: bold;
//     border-bottom-right-radius: 20px;
//     border-bottom-left-radius: 20px;
//     text-align: center;
//     padding: 15px 0;
//     width: 100%;
//     display: inline-block;
// }

// .btn-point {
//     background: $point-color;
//     color: #ffffff;
// }

// .btn-point-line {
//     background: #ffffff;
//     color: $point-color;
//     border: 1px solid $point-color;
// }
</style>
